import React from 'react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'Kit de Arranque Express: Las Primeras 4 Semanas Resueltas',
    desc: 'Diagnóstico inicial + rutina de clase + secuencia para los primeros 20 días sin improvisar.',
    val: '$8.000'
  }, {
    num: '02',
    title: 'Banco de 50 Preguntas Activadoras para Ciencias Sociales',
    desc: '50 preguntas por grado y unidad para generar debate y activar conocimientos previos en 5 minutos.',
    val: '$7.000'
  }, {
    num: '03',
    title: 'Pack de Efemérides Premium (Guiones + Actividades + Cartelería)',
    desc: 'Las 10 fechas patrias resueltas con texto explicativo, palabras alusivas, actividades y sugerencia de acto.',
    val: '$10.000'
  }, {
    num: '04',
    title: 'Kit de Comunicación Docente sin Estrés',
    desc: 'Plantillas listas: comunicado a familias, informe de progreso, carta a dirección y nota al municipio.',
    val: '$6.000'
  }, {
    num: '05',
    title: 'Banco de Mapas Mudos y Líneas de Tiempo (Alta Resolución)',
    desc: '20 mapas + 6 líneas de tiempo históricas en alta resolución para imprimir en A4 o A3.',
    val: '$9.000'
  }, {
    num: '06',
    title: 'Guía de ESI + Ambientes: Respuestas a las Preguntas Difíciles',
    desc: 'Cómo abordar diversidad familiar, dictadura, pueblos originarios y ESI sin conflictos.',
    val: '$8.000'
  }];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[40px] pb-[40px]" data-id="element-15">
      <div className="max-w-6xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-18">
            Más los 6 Bonos{' '}
            <span className="text-brand-accent" data-id="element-19">Estratégicos</span>
          </h2>
          <p className="text-lg text-white/70 font-medium" data-id="element-20">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-21">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-2xl p-6 md:p-8 border border-brand-border relative overflow-hidden flex flex-col" data-id="element-22">
              <div className="text-7xl font-heading font-black text-brand-accent/10 absolute top-2 right-4 leading-none" aria-hidden="true" data-id="element-23">
                {bonus.num}
              </div>
              <div className="relative z-10 flex-grow flex flex-col" data-id="element-24">
                <div className="text-brand-accent font-badge font-black text-sm tracking-widest uppercase mb-4" data-id="element-25">
                  BONO #{bonus.num}
                </div>
                <h3 className="text-xl font-heading font-bold text-white mb-4 pr-8 leading-tight" data-id="element-26">
                  {bonus.title}
                </h3>
                <p className="text-white/70 mb-8 text-sm leading-relaxed flex-grow" data-id="element-27">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between pt-5 border-t border-brand-border mt-auto" data-id="element-28">
                  <div className="text-white/70 line-through text-sm" data-id="element-29">
                    Valor {bonus.val}
                  </div>
                  <div className="text-brand-dark font-black text-sm bg-brand-accent px-4 py-1.5 rounded-full uppercase tracking-wider" data-id="element-30">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="bg-brand-accent/5 rounded-2xl p-8 text-center border border-brand-accent/20 max-w-2xl mx-auto" data-id="element-31">
          <h3 className="text-xl font-heading font-bold text-brand-accent mb-2" data-id="element-32">
            🎁 BONOS GRATIS — Solo por tiempo limitado
          </h3>
          <p className="text-white/70 font-medium" data-id="element-33">
            Incluidos en las 2 ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}